import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './styles/globals.css';
import App from './App';
import { initPWA } from './lib/pwa';
import { initSentry } from './lib/sentry';

initSentry();

// ---------------------------------------------------------------------------
// Update-available state — shared between the SW registration callback and
// the React tree via a simple module-level signal + a custom event.
// ---------------------------------------------------------------------------

function bootstrap() {
  const root = document.getElementById('root');
  if (!root) throw new Error('Root element not found');

  createRoot(root).render(
    <StrictMode>
      <Sentry.ErrorBoundary fallback={<div style={{ padding: '20px' }}>An unexpected error occurred.</div>}>
        <App />
      </Sentry.ErrorBoundary>
    </StrictMode>,
  );

  // Register Service Worker after the app has painted.
  // We dispatch a custom event so AppShell can show the update banner.
  initPWA(() => {
    window.dispatchEvent(new CustomEvent('pwa-update-available'));
  });
}

bootstrap();
